import { Mnemonic } from 'constants/mnemonics';

export enum DepthTypes {
  TVD = 'tvd',
  MD = 'md',
}

export interface SimpleOffsetWellbore {
  tuwbi: string;
  name: string;
  terminaldepthMD?: string;
  seabedRotaryTableDistance?: string;
  groundLevel?: string;
  locationType?: string;
}

export type OffsetWellbore = {
  name: string;
  tuwbi: string;
  lithologies: Lithology[];
  mudLoggingDatas: Record<
    Mnemonic,
    {
      value: number;
      depth: number;
    }[]
  >;
  shoes: Shoe[];
};

export type Lithology = {
  startDepth: number;
  endDepth: number;
  lithotype: string | null;
};
export type Shoe = {
  shoeDepth: number | undefined;
  type: string;
  odSizes: (number | undefined)[];
};
export type GhostModeApiResponse = {
  minDepth: number | undefined;
  maxDepth: number | undefined;
  offsetWellbores: OffsetWellbore[];
};

export interface BestRopRow {
  TVDSS: number | null;
  wellbore_max_rop: string | null;
  ROPAV: number | null;
  WOBAV: number | null;
  RPMAV: number | null;
  TGOUT: number | null;
}
